import React from "react";
import { Navigate } from "react-router-dom";

const DebitNoteAdd = React.lazy(
  () => import("../../../../../components/debit-note/components/add/page"),
);
const DebitNoteIssued = React.lazy(
  () => import("../../../../../components/debit-note/components/list/page"),
);

export const debitNotesRoutes = [
  {
    path: "add",
    element: <DebitNoteAdd />,
  },
  {
    path: "issued",
    element: <DebitNoteIssued />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/debit-notes/issued" />,
  },
];
